<template>
  <div class="alert_wrap">
    <div class="alert_box">
      <div class="alert_msg" v-html="msg"></div>
      <button class="btn_confirm" @click="$emit('AlertEvent', 'close')">{{ $tc("confirm") }}</button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'AlertPopup',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/base.scss";

  .alert_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.6);
    .alert_box {
      display: flex;
      flex-direction: column;
      @include flex-gap(5vh, column);
      padding: 7.5vh 3.90625vw 6.25vh;
      background: $white;
      border-radius: 4vh;
      border: 1px solid #E0E0E0;
      .alert_msg {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 19.875vh;
        color: $black;
        text-align: center;
        font-size: 36px; // IE11 fallback
        font-size: unquote("min(2.8125vw, 36px)");
        font-weight: 700;
        line-height: 6.25vh;
      }
      .btn_confirm {
        display: flex;
        height: 11.75vh;
        min-width: 58.59375vw;
        padding: 3.5vh 0.78125vw;
        justify-content: center;
        align-items: center;
        color: $gray_800;
        text-align: center;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        font-weight: 700;
        line-height: 4.75vh;
        border: none;
        border-radius: 2.5vh;
        background: #E6E8EB;
      }
    }
/*
    .alert_box {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 3px;
      padding: 20px;
      background: $white;
      width: 465px;
      box-sizing: content-box;

      .alert_msg {
        width: 100%;
        padding: 40px 0;
        font-size: 27px;
        line-height: 1.5;
        text-align: center;
        color: $black;
      }
      .btn_confirm {
        width: 100%;
        height: 72px;
        line-height: 72px;
        font-size: 36px;
        background: $positive;
        color: $white;
      }

    } */
  }

</style>
